import { render, staticRenderFns } from "./RecordedArrows.vue?vue&type=template&id=55aac2ac&"
import script from "./RecordedArrows.vue?vue&type=script&lang=js&"
export * from "./RecordedArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecordedArrows.vue"
export default component.exports